
import React from 'react';
import { PatientEditModalTemplate } from 'themes/application/facility-order/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { PatientEditModalViewStore } from 'application/facility-order/stores';

@setCurrentView((rootStore, componentProps) => new PatientEditModalViewStore(rootStore, componentProps), 'patientEditModalViewStore')
@observer
class PatientEditModal extends React.Component {
    render() {
        return <PatientEditModalTemplate {...this.props} />
    }
}

export default PatientEditModal;
